import axios from "axios";
import {
  authHeader,
  authHeaderWithMultipartData,
} from "../authservice/auth-header";

const API_URL = process.env.VUE_APP_ROOT_API

class RoomService {
  // ROOM TYPE LIST RELATED APIs

  //room type list
  getRoomTypeList() {
    return axios
      .get(API_URL + "room/room-type", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create room type
  createRoomType(data) {
    return axios
      .post(API_URL + "room/room-type", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //edit room type
  editRoomType(data, room_type_id) {
    return axios
      .patch(API_URL + "room/room-type/" + room_type_id, data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add room type image priority order
  addRoomTypeImage(room_type_id, data) {
    return axios
      .post(API_URL + "room/" + room_type_id + "/room-type-image", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update room type image priority order
  updateRoomTypeImage(room_type_id, image_id, data) {
    return axios
      .patch(
        API_URL + "room/" + room_type_id + "/room-type-image/" + image_id,
        data,
        {
          headers: authHeaderWithMultipartData(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Delete room type image priority order
  deleteRoomTypeImage(room_type_id, image_id) {
    return axios
      .delete(
        API_URL + "room/" + room_type_id + "/room-type-image/" + image_id,
        {
          headers: authHeaderWithMultipartData(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  // BUILDING RELATED APIs

  //Building list
  getBuildingList() {
    return axios
      .get(API_URL + "room/building", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create building
  createBuilding(data) {
    return axios
      .post(API_URL + "room/building", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //edit building
  editBuilding(data, building_id) {
    return axios
      .patch(API_URL + "room/building/" + building_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete building
  deleteBuilding(building_id) {
    return axios
      .delete(API_URL + "room/building/" + building_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //add photos building
  addPhotoToBuilding(building_id, data) {
    return axios
      .post(API_URL + "room/" + building_id + "/building-image", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //update photos building
  updatePhotoToBuilding(building_id, image_id, data) {
    return axios
      .patch(
        API_URL + "room/" + building_id + "/building-image/" + image_id,
        data,
        {
          headers: authHeaderWithMultipartData(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  //delete photo building
  deletePhotoToBuilding(building_id, image_id) {
    return axios
      .delete(API_URL + "room/" + building_id + "/building-image/" + image_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // FLOOR RELATED RELATED APIs

  // Floor list based on building
  getFloorListByBuilding(query_str) {
    return axios
      .get(API_URL + "room/floor" + query_str, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //Floor list
  getFloorList() {
    return axios
      .get(API_URL + "room/floor", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create floor
  createFloor(data) {
    return axios
      .post(API_URL + "room/floor", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //edit floor
  editFloor(data, floor_id) {
    return axios
      .patch(API_URL + "room/floor/" + floor_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete floor
  deleteFloor(floor_id) {
    return axios
      .delete(API_URL + "room/floor/" + floor_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //add photos floor
  addPhotoToFloor(floor_id, data) {
    return axios
      .post(API_URL + "room/" + floor_id + "/floor-image", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //update photos floor
  updatePhotoToFloor(floor_id, image_id, data) {
    return axios
      .patch(API_URL + "room/" + floor_id + "/floor-image/" + image_id, data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete photo floor
  deletePhotoToFloor(floor_id, image_id) {
    return axios
      .delete(API_URL + "room/" + floor_id + "/floor-image/" + image_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // BED  RELATED APIs

  // bed list
  getBadList() {
    return axios
      .get(API_URL + "room/bad-type", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create bed-type
  createBad(data) {
    return axios
      .post(API_URL + "room/bad-type", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //edit bed-type
  updateBad(data, bad_type_id) {
    return axios
      .patch(API_URL + "room/bad-type/" + bad_type_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete bed-type
  deleteBad(bad_type_id) {
    return axios
      .delete(API_URL + "room/bad-type/" + bad_type_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // ROOM RELATED APIs

  // room get
  getRoomList(filter = "") {
    return axios
      .get(API_URL + "room/list" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // room create
  createRoom(data) {
    return axios
      .post(API_URL + "room/list", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // room edit
  editRoom(data, room_id) {
    return axios
      .patch(API_URL + "room/detail/" + room_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // room detail
  getRoomDetail(room_id) {
    return axios
      .get(API_URL + "room/detail/" + room_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // room edit
  updateRoomStatus(data) {
    return axios
      .post(API_URL + "room/house-keeping/status-change", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // calendar room get
  getRoomListForCalendar(filter = "") {
    return axios
      .get(API_URL + "room/room-calendar" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Search booking rooms from create
  getRoomDetailsForBookingCreate(filter) {
    return axios
      .get(API_URL + "room/booking-rate-plan" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // ROOM AVAILABILITY RELATED APIs

  // room availability
  getRoomAvailability(query_str) {
    return axios
      .get(API_URL + "room/room-availability" + query_str, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update room availability
  updateRoomAvailability(data, room_availability_id) {
    return axios
      .patch(API_URL + "room/room-availability/" + room_availability_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // RATE PLAN RELATED APIs

  //rate plan list
  getRatePlanList() {
    return axios
      .get(API_URL + "room/rate-plan", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create rate plan
  createRatePlan(data) {
    return axios
      .post(API_URL + "room/rate-plan/", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //edit rate plan
  editRatePlan(data, rate_plan_id) {
    return axios
      .patch(API_URL + "room/rate-plan/" + rate_plan_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //rate plan details
  getRatePlanDetails(rate_plan_id) {
    return axios
      .get(API_URL + "room/rate-plan/" + rate_plan_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //rate plan price update
  updateRatePlanPrice(data, rate_plan_price_id) {
    return axios
      .patch(API_URL + "room/rate-plan-price/" + rate_plan_price_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}
export default new RoomService();
